import React from 'react';
import {Link, browserHistory} from 'react-router';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import {ContainerFileDinhKem} from 'components/upload';
import { Input, DatePicker, TextArea, TextMessage, Text, InputNumber} from 'components/tt-forms/common';
import { ShowIf, ShowIfCheck } from 'components/utils';
import { ThanhTra, GiaiQuyetDonThu } from 'api';
import { header } from 'constants/table';
import { RowItemChiTietThanhVienCuocThanhTra, DataTableAttachElement } from 'modules/thanh-tra/datatable';
import {
  DropDownChonLoaiHinhThanhTra,
  DropDownChonLinhVucThanhTra,
  DropDownChonCanCuThanhTraLai,
  DropDownChonDonViChuTriThanhTra,
  DropDownChonTienDoThanhTra,
  DropDownMulipleUse
} from 'components/tt-forms';

const loaiQuyTrinh = 'THANH_TRA';

class ThemMoiCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dotXuat: this.props.dotXuat,
      id: this.props.params.id,
      data: [],
      dataDetail: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: {
        ketLuanTranhTra: [],
        data: []
      },

      listTaiLieuVanThuKetLuanThanhTra: [],
      listTaiLieuVanThu: [],

      dataThanhTraLai: [],
      dataLinhVucThanhTra: [],
      dataDonViChuTri: [],
      dataCoQuanDieuTra: [],
      dataDonViBanHanh: [],
      dataDonViViPham: [],
      dataLoaiHinhThanhTra: [],
      dataHinhThucThanhTra: [],

      dataThanhVienDoan: [],
      dataVaiTroThanhVienDoan:[],

      dataTaiLieuVanThuDelete: [],
      value: '',
      ngayCongBoKQThanhTra: '',
      thoiHanThanhTra: 0,
      ngayHetHanThanhTra:'',

      danhSachDonViPhoiHop: [],
      donViPhoiHop: '',
      danhSachDonViThanhTra: [],
      donViThanhTra: '',
      danhSachDonViViPham: [],
      donViViPham: '',
      danhSachCanCuThanhTraLai: [],
      CanCuThanhTraLai: '',

      // new

      soQuyetDinhThanhLapDoan: '',
      ngayRaQuyetDinhThanhLapDoan: '',

      chuyenCoQuanDieuTra: false,
      phatHienThamNhung: false,
      viPham: false,
      showFile: false,

      caNhanXuLyHanhChinhThamNhung: 0,
      caNhanXuLyHanhChinhViPham: 0,
      canCuThanhTraDotXuat: '',
      canCuThanhTraLai: '',

      coQuanDieuTra: '',
      datDaThu: 0,
      datKhongDungMDSaiQD: 0,
      datKienNghiThuHoi: 0,
      datLanChiem: 0,
      datThamNhung: 0,
      datThuTrongQuaTrinhThanhTra: 0,
      datThuViPham: 0,
      datTraKienNghiKhac: 0,
      datTraKienNghiThuHoi: 0,
      doiTuongThanhTra: '',
      doiTuongThanhTraLienQuan: '',
      doiTuongViPham: '',
      donViBanHanh: '',
      donViChuTri: '',
      hinhThucThanhTra: '',
      kyThanhTra: '',
      linhVucThanhTra: 'HANH_CHINH',
      loaiHinhThanhTra: '',
      ngayBanHanhKetLuanThanhTra: '',
      ngayCongBoQuyetDinhThanhTra: '',
      ngayHetHanGiaHanThanhTra: '',
      ngayRaQuyetDinh: '',
      noiDungThanhTra: '',

      soDoiTuongDieuTra: 0,
      soDoiTuongThamNhung: 0,
      soKetLuanThanhTra: '',
      soNguoiXuLyTrachNhiemDungDau: 0,
      soQuyetDinhVeViecThanhTra: '',
      soTienXuPhatViPham: 0,
      soVuDieuTra: 0,
      soVuThamNhung: 0,
      taiSanKhacDaThu: 0,
      taiSanKhacKienNghiThuHoi: 0,
      taiSanKhacThamNhung: 0,
      ten: '',
      tenNguoi: '',
      thongBaoKetThuc: '',
      tienDaThu: 0,
      tienDoThanhTra: '',
      tienKienNghiThuHoi: 0,
      tienThamNhung: 0,
      tienThuTrongQuaTrinhThanhTra: 0,
      tienThuViPham: 0,
      tienTraKienNghiKhac: 0,
      tienTraKienNghiThuHoi: 0,
      toChucXuLyHanhChinhThamNhung: 0,
      toChucXuLyHanhChinhViPham: 0,
      tomTatKetLuanThanhTra: '',
      giaoDatCapDatSaiDoiTuong : 0,
      capBanDatTraiThamQuyen : 0,
      capGCNQSDDatSai : 0,
      choThueKhongDungQD : 0,
      boHoangHoa : 0,
      viPhamKhac : 0,
      soViPham : 0,
      soQDXuPhatHCDuocBanHanh : 0,
      soTienViPham : 0,
      soTienKienNghiThuHoi : 0,
      soTienTichThuXuLyTaiSanViPham : 0,
      soTienTieuHuyXuLyTaiSanViPham : 0,
      ngayHetHanThanhTraISO: '',
      getThoiHanThanhTra: false,
      isKiemTra: false,
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViChuTri: userInfo.donViId
      })
    }
  }

  componentDidMount() {
    this.getCanCuThanhTraLai();
    this.getLinhVucThanhTra();
    this.getDonViChuTri();
    this.getTienDoThanhTra();
    this.getCoQuanDieuTra();
    this.getDonViBanHanh();
    this.getLoaiHinhThanhTra();
    this.getDoiTuongThanhTra();
    this.getHinhThucThanhTra();
    this.getVaiTroThanhVienDoan();
    if (this.state.dotXuat) {
      this.getDetail(this.state.id);
    } else {
      this.setState({
        showFile: true
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dotXuat: nextProps.dotXuat,
      id: nextProps.params.id
    })
  }

  getDetail(id) {
    ThanhTra.actions.getChiTietCuocThanhTra.request({id: id}).then(res => {
      if(res.data) {
        let Data = res.data;
        let dataCanCuThanhTraLai = [];
        let dataDonViThanhTraLienQuan = [];
        let dataDonViPhoiHop = [];
        let dataDonViViPham = [];
        let dataSelectDonViViPham = [];
        if (Data.canCuThanhTraLai ) {
          let data = Data.canCuThanhTraLai.split('; ');
          data.map(state => {
            dataCanCuThanhTraLai[dataCanCuThanhTraLai.length] = {
              ten: state
            }
          })
        }
        if (Data.doiTuongViPham ) {
          let data = Data.doiTuongViPham.split('; ');
          data.map(state => {
            dataDonViViPham[dataDonViViPham.length] = {
              ten: state
            }
          })
        }
        if (Data.doiTuongThanhTraLienQuan ) {
          let data = Data.doiTuongThanhTraLienQuan.split('; ');
          data.map(state => {
            dataDonViThanhTraLienQuan[dataDonViThanhTraLienQuan.length] = {
              ten: state
            }
          })
        }
        if (Data.donViPhoiHop ) {
          let data = Data.donViPhoiHop.split('; ');
          data.map(state => {
            dataDonViPhoiHop[dataDonViPhoiHop.length] = {
              ten: state
            }
          })
        }
        if (dataDonViThanhTraLienQuan.length > 0) {
          dataDonViThanhTraLienQuan.map(state => {
            dataSelectDonViViPham[dataSelectDonViViPham.length] = {
              giaTri: state.ten,
              ten: state.ten
            }
          })
        }
        this.setState({
          dataDetail: Data,
          ten: Data.ten ? Data.ten : '',
          doiTuongThanhTra: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.doiTuongThanhTraId : '',
          kyThanhTra: Data.kyThanhTra ? Data.kyThanhTra : '',
          noiDungThanhTra: Data.noiDungThanhTra ? Data.noiDungThanhTra : '',
          soQuyetDinhVeViecThanhTra: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '',
          ngayRaQuyetDinh: Data.ngayRaQuyetDinh ? new Date(Data.ngayRaQuyetDinh) : '',
          loaiHinhThanhTra: Data.loaiHinhThanhTra ? Data.loaiHinhThanhTra : '',
          danhSachCanCuThanhTraLai : dataCanCuThanhTraLai,
          phatHienThamNhung: Data.phatHienThamNhung,
          viPham: Data.viPham,

          ngayCongBoQuyetDinhThanhTra: Data.ngayCongBoQuyetDinhThanhTra ? new Date(Data.ngayCongBoQuyetDinhThanhTra) : '',
          thoiHanThanhTra: Data.thoiHanThanhTra ? Data.thoiHanThanhTra : '',
          hinhThucThanhTra: Data.hinhThucThanhTra ? Data.hinhThucThanhTra : '',
          linhVucThanhTra: Data.linhVucThanhTra ? Data.linhVucThanhTra : '',
          canCuThanhTraDotXuat: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '',
          donViChuTri: Data.donViChuTriInfo ? Data.donViChuTriInfo.coQuanQuanLyId : '',
          danhSachDonViPhoiHop: dataDonViPhoiHop,

          danhSachDonViThanhTra: dataDonViThanhTraLienQuan,
          tienDoThanhTra: Data.tienDoThanhTra ? Data.tienDoThanhTra : '',
          soKetLuanThanhTra: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : '',
          ngayBanHanhKetLuanThanhTra: Data.ngayBanHanhKetLuanThanhTra ? new Date(Data.ngayBanHanhKetLuanThanhTra) : '',
          donViBanHanh: Data.donViBanHanh ? Data.donViBanHanh : '',
          tomTatKetLuanThanhTra: Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : '',

          listTaiLieuVanThuKetLuanThanhTra: Data.listTaiLieuVanThuKetLuanThanhTra ? Data.listTaiLieuVanThuKetLuanThanhTra : [],
          listTaiLieuVanThu: Data.listTaiLieuVanThu ? Data.listTaiLieuVanThu : [],

          chuyenCoQuanDieuTra : Data.chuyenCoQuanDieuTra,
          coQuanDieuTra : Data.coQuanDieuTraInfo ? Data.coQuanDieuTraInfo.coQuanQuanLyId : '',
          soVuDieuTra : Data.soVuDieuTra ? Data.soVuDieuTra : 0,
          soDoiTuongDieuTra : Data.soDoiTuongDieuTra ? Data.soDoiTuongDieuTra : 0,

          tienThuViPham : Data.tienThuViPham ? Data.tienThuViPham : 0,
          datThuViPham : Data.datThuViPham ? Data.datThuViPham : 0,
          tienTraKienNghiThuHoi : Data.tienTraKienNghiThuHoi ? Data.tienTraKienNghiThuHoi : 0,
          datTraKienNghiThuHoi : Data.datTraKienNghiThuHoi ? Data.datTraKienNghiThuHoi : 0,
          tienTraKienNghiKhac : Data.tienTraKienNghiKhac ? Data.tienTraKienNghiKhac : 0,
          datTraKienNghiKhac : Data.datTraKienNghiKhac ? Data.datTraKienNghiKhac : 0,
          toChucXuLyHanhChinhViPham : Data.toChucXuLyHanhChinhViPham ? Data.toChucXuLyHanhChinhViPham : 0,
          caNhanXuLyHanhChinhViPham : Data.caNhanXuLyHanhChinhViPham ? Data.caNhanXuLyHanhChinhViPham : 0,
          tienThuTrongQuaTrinhThanhTra : Data.tienThuTrongQuaTrinhThanhTra ? Data.tienThuTrongQuaTrinhThanhTra : 0,
          datThuTrongQuaTrinhThanhTra : Data.datThuTrongQuaTrinhThanhTra ? Data.datThuTrongQuaTrinhThanhTra : 0,
          danhSachDonViViPham: dataDonViViPham,
          dataDonViViPham: dataSelectDonViViPham,

          soVuThamNhung : Data.soVuThamNhung ? Data.soVuThamNhung : 0,
          soDoiTuongThamNhung : Data.soDoiTuongThamNhung ? Data.soDoiTuongThamNhung : 0,
          tienThamNhung : Data.tienThamNhung ? Data.tienThamNhung : 0,
          taiSanKhacThamNhung : Data.taiSanKhacThamNhung ? Data.taiSanKhacThamNhung : 0,
          datThamNhung : Data.datThamNhung ? Data.datThamNhung : 0,
          tienKienNghiThuHoi : Data.tienKienNghiThuHoi ? Data.tienKienNghiThuHoi : 0,
          taiSanKhacKienNghiThuHoi : Data.taiSanKhacKienNghiThuHoi ? Data.taiSanKhacKienNghiThuHoi : 0,
          datKienNghiThuHoi : Data.datKienNghiThuHoi ? Data.datKienNghiThuHoi : 0,
          tienDaThu : Data.tienDaThu ? Data.tienDaThu : 0,
          taiSanKhacDaThu : Data.taiSanKhacDaThu ? Data.taiSanKhacDaThu : 0,
          datDaThu : Data.datDaThu ? Data.datDaThu : 0,
          toChucXuLyHanhChinhThamNhung : Data.toChucXuLyHanhChinhThamNhung ? Data.toChucXuLyHanhChinhThamNhung : 0,
          caNhanXuLyHanhChinhThamNhung : Data.caNhanXuLyHanhChinhThamNhung ? Data.caNhanXuLyHanhChinhThamNhung : 0,
          soNguoiXuLyTrachNhiemDungDau : Data.soNguoiXuLyTrachNhiemDungDau ? Data.soNguoiXuLyTrachNhiemDungDau : 0,
          tenNguoi : Data.tenNguoi ? Data.tenNguoi : '',
          showFile: true,
          ngayHetHanThanhTra: Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '',
          ngayHetHanThanhTraISO: Data.ngayHetHanThanhTra ? Data.ngayHetHanThanhTra : null,

          thanhLapDoan: Data.thanhLapDoan,
          soQuyetDinhThanhLapDoan : Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : '',
          ngayRaQuyetDinhThanhLapDoan : Data.ngayRaQuyetDinhThanhLapDoan ? new Date(Data.ngayRaQuyetDinhThanhLapDoan) : '',
          dataThanhVienDoan: Data.listThanhVienDoan ? Data.listThanhVienDoan : [],

          datLanChiem: Data.datLanChiem ? Data.datLanChiem : 0 ,
          giaoDatCapDatSaiDoiTuong: Data.giaoDatCapDatSaiDoiTuong ? Data.giaoDatCapDatSaiDoiTuong : 0 ,
          capBanDatTraiThamQuyen: Data.capBanDatTraiThamQuyen ? Data.capBanDatTraiThamQuyen : 0 ,
          capGCNQSDDatSai: Data.capGCNQSDDatSai ? Data.capGCNQSDDatSai : 0 ,
          choThueKhongDungQD: Data.choThueKhongDungQD ? Data.choThueKhongDungQD : 0 ,
          datKhongDungMDSaiQD: Data.datKhongDungMDSaiQD ? Data.datKhongDungMDSaiQD : 0 ,
          boHoangHoa: Data.boHoangHoa ? Data.boHoangHoa : 0 ,
          viPhamKhac: Data.viPhamKhac ? Data.viPhamKhac : 0 ,
          soViPham: Data.soViPham ? Data.soViPham : 0 ,
          soQDXuPhatHCDuocBanHanh: Data.soQDXuPhatHCDuocBanHanh ? Data.soQDXuPhatHCDuocBanHanh : 0 ,
          soTienViPham: Data.soTienViPham ? Data.soTienViPham : 0 ,
          soTienXuPhatViPham: Data.soTienXuPhatViPham ? Data.soTienXuPhatViPham : 0 ,
          soTienKienNghiThuHoi: Data.soTienKienNghiThuHoi ? Data.soTienKienNghiThuHoi : 0 ,
          soTienTichThuXuLyTaiSanViPham: Data.soTienTichThuXuLyTaiSanViPham ? Data.soTienTichThuXuLyTaiSanViPham : 0 ,
          soTienTieuHuyXuLyTaiSanViPham: Data.soTienTieuHuyXuLyTaiSanViPham ? Data.soTienTieuHuyXuLyTaiSanViPham : 0,
          isKiemTra: Data.loaiCuoc.value === 'KIEM_TRA',
        })
      }

    })
  }

  getCanCuThanhTraLai() {
    ThanhTra.actions.getCanCuThanhTraLai.request().then(res => {
      if (res.data) {
        this.setState({
          dataThanhTraLai: res.data
        })
      }
    })
  }

  getLinhVucThanhTra() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataLinhVucThanhTra: res.data
        })
      }
    })
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViChuTri.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViChuTri: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getTienDoThanhTra() {
    ThanhTra.actions.getTienDoThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataTienDoThanhTra: res.data
        })
      }
    })
  }

  getCoQuanDieuTra() {
    ThanhTra.actions.getCoQuanDieuTra.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataCoQuanDieuTra: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getDonViBanHanh() {
    ThanhTra.actions.getListDonViBanHanh.request().then(res => {
      if (res.data) {
        this.setState({
          dataDonViBanHanh: res.data
        })
      }
    })
  }

  getLoaiHinhThanhTra() {
    ThanhTra.actions.getLoaiHinhThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataLoaiHinhThanhTra: res.data
        })
      }
    })
  }

  getDoiTuongThanhTra() {
    let d = new Date();
    let getNamTT = d.getFullYear() + 1;
    ThanhTra.actions.getDoiTuongThanhTra.request({namThanhTra: getNamTT}).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
        })
      }
    })
  }

  getHinhThucThanhTra() {
    ThanhTra.actions.getHinhThucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataHinhThucThanhTra: res.data
        })
      }
    })
  }

  getVaiTroThanhVienDoan() {
    ThanhTra.actions.getVaiTroThanhVienDoan.request().then(res => {
      if (res.data) {
        this.setState({
          dataVaiTroThanhVienDoan: res.data
        })
      }
    })
  }

  handleSave() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      })
      let params = this.getParams();
      ThanhTra.actions.postCuocThanhTra.request('',params).then(res => {
        if (res.data) {
          let idCuocThanhTra = res.data.cuocThanhTraId
          this.pushTaiLieu(idCuocThanhTra);
          this.onClickClose();
          Toastr(msg.saveCuocTTSuccess, 'success');
        }
      }).catch(error => {
        if (error.response.data.errors) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          btnLoading: false,
          btnSaveLoading: false
        })
      });
    }
  }

  onClickClose() {
    browserHistory.goBack();
  }

  pushTaiLieu(id) {

    let dataFileDinhKem = this.getListDataFileDinhKem();

    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            cuocThanhTra: {
              id: Number(id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            cuocThanhTra: {
              id: Number(id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }

    if(this.state.taiLieuVanThu.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThu
      }
      this.postTaiLieuVanThu(params);
    }

    if(this.state.taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuUpdate
      }
      this.updateTaiLieuVanThu(params);
    }

    if(this.state.taiLieuVanThuDelete.length > 0) {

      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuDelete
      }
      this.deleteTaiLieuVanThu(params);
    }
  }

  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  getParams() {
    let donViPhoiHop = '';
    let donViThanhTra = '';
    let donViViPham = '';
    let canCuThanhTraLai = '';

    if (this.state.danhSachDonViPhoiHop.length > 0) {
      this.state.danhSachDonViPhoiHop.map((state, index) => {
        if (index == 0) {
          donViPhoiHop = donViPhoiHop + state.ten
        } else {
          donViPhoiHop = donViPhoiHop + '; ' + state.ten
        }
      })
    }

    if (this.state.danhSachDonViThanhTra.length > 0) {
      this.state.danhSachDonViThanhTra.map((state, index) => {
        if (index == 0) {
          donViThanhTra = donViThanhTra + state.ten
        } else {
          donViThanhTra = donViThanhTra + '; ' + state.ten
        }
      })
    }

    if (this.state.danhSachDonViViPham.length > 0) {
      this.state.danhSachDonViViPham.map((state, index) => {
        if (index == 0) {
          donViViPham = donViViPham + state.ten
        } else {
          donViViPham = donViViPham + '; ' + state.ten
        }
      })
    }

    if (this.state.danhSachCanCuThanhTraLai.length > 0) {
      this.state.danhSachCanCuThanhTraLai.map((state, index) => {
        if (index == 0) {
          canCuThanhTraLai = canCuThanhTraLai + state.ten
        } else {
          canCuThanhTraLai = canCuThanhTraLai + '; ' + state.ten
        }
      })
    }

    let params = {
      ten: this.state.ten ? this.state.ten : '',
      doiTuongThanhTra: {
        id: Number(this.state.doiTuongThanhTra)
      },
      kyThanhTra: this.state.kyThanhTra ? this.state.kyThanhTra : '',
      noiDungThanhTra: this.state.noiDungThanhTra ? this.state.noiDungThanhTra : '',
      soQuyetDinhVeViecThanhTra: this.state.soQuyetDinhVeViecThanhTra ? this.state.soQuyetDinhVeViecThanhTra : '',
      ngayRaQuyetDinh: this.state.ngayRaQuyetDinh ? moment(this.state.ngayRaQuyetDinh).add( 7, 'hours').toISOString() : null,
      loaiHinhThanhTra: this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : null,
      ngayCongBoQuyetDinhThanhTra: this.state.ngayCongBoQuyetDinhThanhTra ? moment(this.state.ngayCongBoQuyetDinhThanhTra).add( 7, 'hours').toISOString() : null,
      thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
      hinhThucThanhTra: this.state.hinhThucThanhTra ? this.state.hinhThucThanhTra : null,
      linhVucThanhTra: this.state.linhVucThanhTra ? this.state.linhVucThanhTra : null,
      donViPhoiHop: donViPhoiHop,
      doiTuongThanhTraLienQuan: donViThanhTra,
      tienDoThanhTra: this.state.tienDoThanhTra ? this.state.tienDoThanhTra : null,
      soKetLuanThanhTra: this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '',
      tomTatKetLuanThanhTra: this.state.tomTatKetLuanThanhTra ? this.state.tomTatKetLuanThanhTra : '',
      ngayBanHanhKetLuanThanhTra: this.state.ngayBanHanhKetLuanThanhTra ? moment(this.state.ngayBanHanhKetLuanThanhTra).add( 7, 'hours').toISOString() : null,
      donViBanHanh: this.state.donViBanHanh ? this.state.donViBanHanh : null
    }

    params.ngayHetHanThanhTra = this.state.ngayHetHanThanhTraISO ? this.state.ngayHetHanThanhTraISO : null;

    if (this.state.hinhThucThanhTra == 'DOT_XUAT') {
      params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
    } else {
      params.canCuThanhTraDotXuat = '';
    }

    if(this.state.loaiHinhThanhTra == 'THANH_TRA_LAI') {
      params.canCuThanhTraLai = canCuThanhTraLai;
    } else {
      params.canCuThanhTraLai = '';
    }

    if (this.state.donViChuTri) {
      params.donViChuTri = {
        id: Number(this.state.donViChuTri)
      }
    } else {
      params.donViChuTri = null;
    }

    if (this.state.chuyenCoQuanDieuTra) {
      params.chuyenCoQuanDieuTra = true;
      if (this.state.coQuanDieuTra) {
        params.coQuanDieuTra = {
          id: Number(this.state.coQuanDieuTra)
        }
      } else {
        params.coQuanDieuTra = null;
      }
      params.soVuDieuTra = this.state.soVuDieuTra ? Number(this.state.soVuDieuTra) : 0;
      params.soDoiTuongDieuTra = this.state.soDoiTuongDieuTra ? Number(this.state.soDoiTuongDieuTra) : 0;
    } else {
      params.chuyenCoQuanDieuTra = false;
      params.coQuanDieuTra = null;
      params.soVuDieuTra = 0;
      params.soDoiTuongDieuTra = 0;
    }

    if (this.state.viPham) {
      params.viPham = true;
      params.tienThuViPham = this.state.tienThuViPham ? this.state.tienThuViPham : 0;
      params.datThuViPham = this.state.datThuViPham ? this.state.datThuViPham : 0;
      params.datLanChiem = this.state.datLanChiem ? this.state.datLanChiem : 0;
      params.giaoDatCapDatSaiDoiTuong = this.state.giaoDatCapDatSaiDoiTuong ? this.state.giaoDatCapDatSaiDoiTuong : 0;
      params.capBanDatTraiThamQuyen = this.state.capBanDatTraiThamQuyen ? this.state.capBanDatTraiThamQuyen : 0;
      params.capGCNQSDDatSai = this.state.capGCNQSDDatSai ? this.state.capGCNQSDDatSai : 0;
      params.choThueKhongDungQD = this.state.choThueKhongDungQD ? this.state.choThueKhongDungQD : 0;
      params.datKhongDungMDSaiQD = this.state.datKhongDungMDSaiQD ? this.state.datKhongDungMDSaiQD : 0;
      params.boHoangHoa = this.state.boHoangHoa ? this.state.boHoangHoa : 0;
      params.viPhamKhac = this.state.viPhamKhac ? this.state.viPhamKhac : 0;
      params.tienTraKienNghiThuHoi = this.state.tienTraKienNghiThuHoi ? this.state.tienTraKienNghiThuHoi : 0;
      params.datTraKienNghiThuHoi = this.state.datTraKienNghiThuHoi ? this.state.datTraKienNghiThuHoi : 0;
      params.tienTraKienNghiKhac = this.state.tienTraKienNghiKhac ? this.state.tienTraKienNghiKhac : 0;
      params.datTraKienNghiKhac = this.state.datTraKienNghiKhac ? this.state.datTraKienNghiKhac : 0;
      params.toChucXuLyHanhChinhViPham = this.state.toChucXuLyHanhChinhViPham ? this.state.toChucXuLyHanhChinhViPham : 0;
      params.caNhanXuLyHanhChinhViPham = this.state.caNhanXuLyHanhChinhViPham ? this.state.caNhanXuLyHanhChinhViPham : 0;
      params.tienThuTrongQuaTrinhThanhTra = this.state.tienThuTrongQuaTrinhThanhTra ? this.state.tienThuTrongQuaTrinhThanhTra : 0;
      params.datThuTrongQuaTrinhThanhTra = this.state.datThuTrongQuaTrinhThanhTra ? this.state.datThuTrongQuaTrinhThanhTra : 0;
      params.soViPham = this.state.soViPham ? this.state.soViPham : 0;
      params.soQDXuPhatHCDuocBanHanh = this.state.soQDXuPhatHCDuocBanHanh ? this.state.soQDXuPhatHCDuocBanHanh : 0;
      params.soTienViPham = this.state.soTienViPham ? this.state.soTienViPham : 0;
      params.soTienXuPhatViPham = this.state.soTienXuPhatViPham ? this.state.soTienXuPhatViPham : 0;
      params.soTienKienNghiThuHoi = this.state.soTienKienNghiThuHoi ? this.state.soTienKienNghiThuHoi : 0;
      params.soTienTichThuXuLyTaiSanViPham = this.state.soTienTichThuXuLyTaiSanViPham ? this.state.soTienTichThuXuLyTaiSanViPham : 0;
      params.soTienTieuHuyXuLyTaiSanViPham = this.state.soTienTieuHuyXuLyTaiSanViPham ? this.state.soTienTieuHuyXuLyTaiSanViPham : 0;
      params.doiTuongViPham = donViViPham;
    } else {
      params.viPham = false;
      params.tienThuViPham = 0;
      params.datThuViPham = 0;
      params.datLanChiem = 0;
      params.giaoDatCapDatSaiDoiTuong = 0;
      params.capBanDatTraiThamQuyen = 0;
      params.capGCNQSDDatSai = 0;
      params.choThueKhongDungQD = 0;
      params.datKhongDungMDSaiQD = 0;
      params.boHoangHoa = 0;
      params.viPhamKhac = 0;
      params.tienTraKienNghiThuHoi = 0;
      params.datTraKienNghiThuHoi = 0;
      params.tienTraKienNghiKhac = 0;
      params.datTraKienNghiKhac = 0;
      params.toChucXuLyHanhChinhViPham = 0;
      params.caNhanXuLyHanhChinhViPham = 0;
      params.tienThuTrongQuaTrinhThanhTra = 0;
      params.datThuTrongQuaTrinhThanhTra = 0;
      params.soViPham = 0;
      params.soQDXuPhatHCDuocBanHanh = 0;
      params.soTienViPham = 0;
      params.soTienXuPhatViPham = 0;
      params.soTienKienNghiThuHoi = 0;
      params.soTienTichThuXuLyTaiSanViPham = 0;
      params.soTienTieuHuyXuLyTaiSanViPham = 0;
      params.doiTuongViPham = '';
    }

    if (this.state.phatHienThamNhung) {
      params.phatHienThamNhung = true;
      params.soVuThamNhung = this.state.soVuThamNhung ? Number(this.state.soVuThamNhung) : 0;
      params.soDoiTuongThamNhung = this.state.soDoiTuongThamNhung ? Number(this.state.soDoiTuongThamNhung) : 0;
      params.tienThamNhung = this.state.tienThamNhung ? Number(this.state.tienThamNhung) : 0;
      params.taiSanKhacThamNhung = this.state.taiSanKhacThamNhung ? Number(this.state.taiSanKhacThamNhung) : 0;
      params.datThamNhung = this.state.datThamNhung ? Number(this.state.datThamNhung) : 0;
      params.tienKienNghiThuHoi = this.state.tienKienNghiThuHoi ? Number(this.state.tienKienNghiThuHoi) : 0;
      params.taiSanKhacKienNghiThuHoi = this.state.taiSanKhacKienNghiThuHoi ? Number(this.state.taiSanKhacKienNghiThuHoi) : 0;
      params.datKienNghiThuHoi = this.state.datKienNghiThuHoi ? Number(this.state.datKienNghiThuHoi) : 0;
      params.tienDaThu = this.state.tienDaThu ? Number(this.state.tienDaThu) : 0;
      params.taiSanKhacDaThu = this.state.taiSanKhacDaThu ? Number(this.state.taiSanKhacDaThu) : 0;
      params.datDaThu = this.state.datDaThu ? Number(this.state.datDaThu) : 0;
      params.toChucXuLyHanhChinhThamNhung = this.state.toChucXuLyHanhChinhThamNhung ? Number(this.state.toChucXuLyHanhChinhThamNhung) : 0;
      params.caNhanXuLyHanhChinhThamNhung = this.state.caNhanXuLyHanhChinhThamNhung ? Number(this.state.caNhanXuLyHanhChinhThamNhung) : 0;
      params.soNguoiXuLyTrachNhiemDungDau = this.state.soNguoiXuLyTrachNhiemDungDau ? Number(this.state.soNguoiXuLyTrachNhiemDungDau) : 0;
      params.tenNguoi = this.state.tenNguoi ? this.state.tenNguoi : '';
    } else {
      params.phatHienThamNhung = false;
      params.soVuThamNhung = 0;
      params.soDoiTuongThamNhung = 0;
      params.tienThamNhung = 0;
      params.taiSanKhacThamNhung = 0;
      params.datThamNhung = 0;
      params.tienKienNghiThuHoi = 0;
      params.taiSanKhacKienNghiThuHoi = 0;
      params.datKienNghiThuHoi = 0;
      params.tienDaThu = 0;
      params.taiSanKhacDaThu = 0;
      params.datDaThu = 0;
      params.toChucXuLyHanhChinhThamNhung = 0;
      params.caNhanXuLyHanhChinhThamNhung = 0;
      params.soNguoiXuLyTrachNhiemDungDau = 0;
      params.tenNguoi = '';
    }

    if (this.state.thanhLapDoan && this.state.linhVucThanhTra == 'CHUYEN_NGANH') {
      params.thanhLapDoan = true;
      params.soQuyetDinhThanhLapDoan = this.state.soQuyetDinhThanhLapDoan ? this.state.soQuyetDinhThanhLapDoan : '';
      params.ngayRaQuyetDinhThanhLapDoan = this.state.ngayRaQuyetDinhThanhLapDoan ? moment(this.state.ngayRaQuyetDinhThanhLapDoan).add(7, 'hours').toISOString() : '';
      params.thanhVienDoans = this.state.dataThanhVienDoan;
    } else {
      params.thanhLapDoan = false;
      params.soQuyetDinhThanhLapDoan = '';
      params.ngayRaQuyetDinhThanhLapDoan = null;
      params.thanhVienDoans = []
    }

    return params;
  }

  checkIsKiemTra() {
    const result = window.location.pathname.includes('kiem-tra') || this.state.isKiemTra;
    return result;
  }

  handleSaveExistElement() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      })
      let params = this.getParamsExistElement();
      params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
      ThanhTra.actions.patchCuocThanhTra.request({id: this.state.id}, params).then(res => {
        if (res.data) {
          this.pushTaiLieu(this.state.id);
          this.onClickClose();
          Toastr(msg.saveCuocTTSuccess, 'success');
        }
      }).catch(error => {
        if (error.response.data.errors) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          btnLoading: false,
          btnSaveLoading: false
        })
      });
    }
  }

  getParamsExistElement() {

    let donViPhoiHop = '';
    let donViThanhTra = '';
    let donViViPham = '';
    let canCuThanhTraLai = '';

    if (this.state.danhSachDonViPhoiHop.length > 0) {
      this.state.danhSachDonViPhoiHop.map((state, index) => {
        if (index == 0) {
          donViPhoiHop = donViPhoiHop + state.ten
        } else {
          donViPhoiHop = donViPhoiHop + '; ' + state.ten
        }
      })
    }

    if (this.state.danhSachDonViThanhTra.length > 0) {
      this.state.danhSachDonViThanhTra.map((state, index) => {
        if (index == 0) {
          donViThanhTra = donViThanhTra + state.ten
        } else {
          donViThanhTra = donViThanhTra + '; ' + state.ten
        }
      })
    }

    if (this.state.danhSachDonViViPham.length > 0) {
      this.state.danhSachDonViViPham.map((state, index) => {
        if (index == 0) {
          donViViPham = donViViPham + state.ten
        } else {
          donViViPham = donViViPham + '; ' + state.ten
        }
      })
    }

    if (this.state.danhSachCanCuThanhTraLai.length > 0) {
      this.state.danhSachCanCuThanhTraLai.map((state, index) => {
        if (index == 0) {
          canCuThanhTraLai = canCuThanhTraLai + state.ten
        } else {
          canCuThanhTraLai = canCuThanhTraLai + '; ' + state.ten
        }
      })
    }

    let params = this.state.dataDetail;

    params.ten = this.state.ten ? this.state.ten : '';
    params.doiTuongThanhTra = {
      id: Number(this.state.doiTuongThanhTra)
    };
    params.kyThanhTra = this.state.kyThanhTra ? this.state.kyThanhTra : '';
    params.noiDungThanhTra = this.state.noiDungThanhTra ? this.state.noiDungThanhTra : '';
    params.soQuyetDinhVeViecThanhTra = this.state.soQuyetDinhVeViecThanhTra ? this.state.soQuyetDinhVeViecThanhTra : '';
    params.ngayRaQuyetDinh = this.state.ngayRaQuyetDinh ? moment(this.state.ngayRaQuyetDinh).add( 7, 'hours').toISOString() : null;
    params.loaiHinhThanhTra = this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : null;
    params.ngayCongBoQuyetDinhThanhTra = this.state.ngayCongBoQuyetDinhThanhTra ? moment(this.state.ngayCongBoQuyetDinhThanhTra).add( 7, 'hours').toISOString() : null;
    params.thoiHanThanhTra = this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0;
    params.linhVucThanhTra = this.state.linhVucThanhTra ? this.state.linhVucThanhTra : null;
    params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
    params.donViPhoiHop = donViPhoiHop;
    params.doiTuongThanhTraLienQuan = donViThanhTra;
    params.tienDoThanhTra = this.state.tienDoThanhTra ? this.state.tienDoThanhTra : null;
    params.soKetLuanThanhTra = this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '';
    params.tomTatKetLuanThanhTra = this.state.tomTatKetLuanThanhTra ? this.state.tomTatKetLuanThanhTra : '';
    params.ngayBanHanhKetLuanThanhTra = this.state.ngayBanHanhKetLuanThanhTra ? moment(this.state.ngayBanHanhKetLuanThanhTra).add( 7, 'hours').toISOString() : null;
    params.donViBanHanh = this.state.donViBanHanh ? this.state.donViBanHanh : null;

    params.ngayHetHanThanhTra = this.state.ngayHetHanThanhTraISO ? this.state.ngayHetHanThanhTraISO : null;

     if (this.state.hinhThucThanhTra == 'DOT_XUAT') {
      params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
    } else {
      params.canCuThanhTraDotXuat = '';
    }

    if(this.state.loaiHinhThanhTra == 'THANH_TRA_LAI') {
      params.canCuThanhTraLai = canCuThanhTraLai;
    } else {
      params.canCuThanhTraLai = '';
    }

    if (this.state.donViChuTri) {
      params.donViChuTri = {
        id: Number(this.state.donViChuTri)
      }
    } else {
      params.donViChuTri = null;
    }

    if (this.state.chuyenCoQuanDieuTra) {
      params.chuyenCoQuanDieuTra = true;
      if (this.state.coQuanDieuTra) {
        params.coQuanDieuTra = {
          id: Number(this.state.coQuanDieuTra)
        }
      } else {
        params.coQuanDieuTra = null;
      }
      params.soVuDieuTra = this.state.soVuDieuTra ? Number(this.state.soVuDieuTra) : 0;
      params.soDoiTuongDieuTra = this.state.soDoiTuongDieuTra ? Number(this.state.soDoiTuongDieuTra) : 0;
    } else {
      params.chuyenCoQuanDieuTra = false;
      params.coQuanDieuTra = null;
      params.soVuDieuTra = 0;
      params.soDoiTuongDieuTra = 0;
    }

    if (this.state.viPham) {
      params.viPham = true;
      params.tienThuViPham = this.state.tienThuViPham ? this.state.tienThuViPham : 0;
      params.datThuViPham = this.state.datThuViPham ? this.state.datThuViPham : 0;
      params.datLanChiem = this.state.datLanChiem ? this.state.datLanChiem : 0;
      params.giaoDatCapDatSaiDoiTuong = this.state.giaoDatCapDatSaiDoiTuong ? this.state.giaoDatCapDatSaiDoiTuong : 0;
      params.capBanDatTraiThamQuyen = this.state.capBanDatTraiThamQuyen ? this.state.capBanDatTraiThamQuyen : 0;
      params.capGCNQSDDatSai = this.state.capGCNQSDDatSai ? this.state.capGCNQSDDatSai : 0;
      params.choThueKhongDungQD = this.state.choThueKhongDungQD ? this.state.choThueKhongDungQD : 0;
      params.datKhongDungMDSaiQD = this.state.datKhongDungMDSaiQD ? this.state.datKhongDungMDSaiQD : 0;
      params.boHoangHoa = this.state.boHoangHoa ? this.state.boHoangHoa : 0;
      params.viPhamKhac = this.state.viPhamKhac ? this.state.viPhamKhac : 0;
      params.tienTraKienNghiThuHoi = this.state.tienTraKienNghiThuHoi ? this.state.tienTraKienNghiThuHoi : 0;
      params.datTraKienNghiThuHoi = this.state.datTraKienNghiThuHoi ? this.state.datTraKienNghiThuHoi : 0;
      params.tienTraKienNghiKhac = this.state.tienTraKienNghiKhac ? this.state.tienTraKienNghiKhac : 0;
      params.datTraKienNghiKhac = this.state.datTraKienNghiKhac ? this.state.datTraKienNghiKhac : 0;
      params.toChucXuLyHanhChinhViPham = this.state.toChucXuLyHanhChinhViPham ? this.state.toChucXuLyHanhChinhViPham : 0;
      params.caNhanXuLyHanhChinhViPham = this.state.caNhanXuLyHanhChinhViPham ? this.state.caNhanXuLyHanhChinhViPham : 0;
      params.tienThuTrongQuaTrinhThanhTra = this.state.tienThuTrongQuaTrinhThanhTra ? this.state.tienThuTrongQuaTrinhThanhTra : 0;
      params.datThuTrongQuaTrinhThanhTra = this.state.datThuTrongQuaTrinhThanhTra ? this.state.datThuTrongQuaTrinhThanhTra : 0;
      params.soViPham = this.state.soViPham ? this.state.soViPham : 0;
      params.soQDXuPhatHCDuocBanHanh = this.state.soQDXuPhatHCDuocBanHanh ? this.state.soQDXuPhatHCDuocBanHanh : 0;
      params.soTienViPham = this.state.soTienViPham ? this.state.soTienViPham : 0;
      params.soTienXuPhatViPham = this.state.soTienXuPhatViPham ? this.state.soTienXuPhatViPham : 0;
      params.soTienKienNghiThuHoi = this.state.soTienKienNghiThuHoi ? this.state.soTienKienNghiThuHoi : 0;
      params.soTienTichThuXuLyTaiSanViPham = this.state.soTienTichThuXuLyTaiSanViPham ? this.state.soTienTichThuXuLyTaiSanViPham : 0;
      params.soTienTieuHuyXuLyTaiSanViPham = this.state.soTienTieuHuyXuLyTaiSanViPham ? this.state.soTienTieuHuyXuLyTaiSanViPham : 0;
      params.doiTuongViPham = donViViPham;
    } else {
      params.viPham = false;
      params.tienThuViPham = 0;
      params.datThuViPham = 0;
      params.datLanChiem = 0;
      params.giaoDatCapDatSaiDoiTuong = 0;
      params.capBanDatTraiThamQuyen = 0;
      params.capGCNQSDDatSai = 0;
      params.choThueKhongDungQD = 0;
      params.datKhongDungMDSaiQD = 0;
      params.boHoangHoa = 0;
      params.viPhamKhac = 0;
      params.tienTraKienNghiThuHoi = 0;
      params.datTraKienNghiThuHoi = 0;
      params.tienTraKienNghiKhac = 0;
      params.datTraKienNghiKhac = 0;
      params.toChucXuLyHanhChinhViPham = 0;
      params.caNhanXuLyHanhChinhViPham = 0;
      params.tienThuTrongQuaTrinhThanhTra = 0;
      params.datThuTrongQuaTrinhThanhTra = 0;
      params.soViPham = 0;
      params.soQDXuPhatHCDuocBanHanh = 0;
      params.soTienViPham = 0;
      params.soTienXuPhatViPham = 0;
      params.soTienKienNghiThuHoi = 0;
      params.soTienTichThuXuLyTaiSanViPham = 0;
      params.soTienTieuHuyXuLyTaiSanViPham = 0;
      params.doiTuongViPham = '';
    }

    if (this.state.phatHienThamNhung) {
      params.phatHienThamNhung = true;
      params.soVuThamNhung = this.state.soVuThamNhung ? Number(this.state.soVuThamNhung) : 0;
      params.soDoiTuongThamNhung = this.state.soDoiTuongThamNhung ? Number(this.state.soDoiTuongThamNhung) : 0;
      params.tienThamNhung = this.state.tienThamNhung ? Number(this.state.tienThamNhung) : 0;
      params.taiSanKhacThamNhung = this.state.taiSanKhacThamNhung ? Number(this.state.taiSanKhacThamNhung) : 0;
      params.datThamNhung = this.state.datThamNhung ? Number(this.state.datThamNhung) : 0;
      params.tienKienNghiThuHoi = this.state.tienKienNghiThuHoi ? Number(this.state.tienKienNghiThuHoi) : 0;
      params.taiSanKhacKienNghiThuHoi = this.state.taiSanKhacKienNghiThuHoi ? Number(this.state.taiSanKhacKienNghiThuHoi) : 0;
      params.datKienNghiThuHoi = this.state.datKienNghiThuHoi ? Number(this.state.datKienNghiThuHoi) : 0;
      params.tienDaThu = this.state.tienDaThu ? Number(this.state.tienDaThu) : 0;
      params.taiSanKhacDaThu = this.state.taiSanKhacDaThu ? Number(this.state.taiSanKhacDaThu) : 0;
      params.datDaThu = this.state.datDaThu ? Number(this.state.datDaThu) : 0;
      params.toChucXuLyHanhChinhThamNhung = this.state.toChucXuLyHanhChinhThamNhung ? Number(this.state.toChucXuLyHanhChinhThamNhung) : 0;
      params.caNhanXuLyHanhChinhThamNhung = this.state.caNhanXuLyHanhChinhThamNhung ? Number(this.state.caNhanXuLyHanhChinhThamNhung) : 0;
      params.soNguoiXuLyTrachNhiemDungDau = this.state.soNguoiXuLyTrachNhiemDungDau ? Number(this.state.soNguoiXuLyTrachNhiemDungDau) : 0;
      params.tenNguoi = this.state.tenNguoi ? this.state.tenNguoi : '';
    } else {
      params.phatHienThamNhung = false;
      params.soVuThamNhung = 0;
      params.soDoiTuongThamNhung = 0;
      params.tienThamNhung = 0;
      params.taiSanKhacThamNhung = 0;
      params.datThamNhung = 0;
      params.tienKienNghiThuHoi = 0;
      params.taiSanKhacKienNghiThuHoi = 0;
      params.datKienNghiThuHoi = 0;
      params.tienDaThu = 0;
      params.taiSanKhacDaThu = 0;
      params.datDaThu = 0;
      params.toChucXuLyHanhChinhThamNhung = 0;
      params.caNhanXuLyHanhChinhThamNhung = 0;
      params.soNguoiXuLyTrachNhiemDungDau = 0;
      params.tenNguoi = '';
    }

    if (this.state.thanhLapDoan && this.state.linhVucThanhTra == 'CHUYEN_NGANH') {
      params.thanhLapDoan = true;
      params.soQuyetDinhThanhLapDoan = this.state.soQuyetDinhThanhLapDoan ? this.state.soQuyetDinhThanhLapDoan : '';
      params.ngayRaQuyetDinhThanhLapDoan = this.state.ngayRaQuyetDinhThanhLapDoan ? moment(this.state.ngayRaQuyetDinhThanhLapDoan).add(7, 'hours').toISOString() : '';
      params.thanhVienDoans = this.state.dataThanhVienDoan;
    } else {
      params.thanhLapDoan = false;
      params.soQuyetDinhThanhLapDoan = '';
      params.ngayRaQuyetDinhThanhLapDoan = null;
      params.thanhVienDoans = []
    }

    delete params['_links'];
    delete params['nguoiSuaInfo'];
    delete params['nguoiTaoInfo'];
    delete params['ngaySua'];
    delete params['ngayTao'];
    delete params['coQuanDieuTraInfo'];
    delete params['doiTuongThanhTraInfo'];
    delete params['donViChuTriInfo'];
    delete params['donViInfo'];
    delete params['hinhThucThanhTraInfo'];
    delete params['linhVucThanhTraInfo'];
    delete params['loaiHinhThanhTraInfo'];
    delete params['listTaiLieuVanThu'];
    delete params['listTaiLieuVanThuGiaHan'];
    delete params['listTaiLieuVanThuKetLuanThanhTra'];
    delete params['cuocThanhTraId'];
    delete params['listThanhVienDoan'];
    delete params['tienDoThanhTraInfo'];

    return params;
  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.ketLuanTranhTra.length > 0) {
      Data.ketLuanTranhTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  resetData() {
    this.setState({
      tienThuViPham : 0,
      datThuViPham : 0,
      datLanChiem : 0,
      giaoDatCapDatSaiDoiTuong : 0,
      capBanDatTraiThamQuyen : 0,
      capGCNQSDDatSai : 0,
      choThueKhongDungQD : 0,
      datKhongDungMDSaiQD : 0,
      boHoangHoa : 0,
      viPhamKhac : 0,
      tienTraKienNghiThuHoi : 0,
      datTraKienNghiThuHoi : 0,
      tienTraKienNghiKhac : 0,
      datTraKienNghiKhac : 0,
      toChucXuLyHanhChinhViPham : 0,
      caNhanXuLyHanhChinhViPham : 0,
      tienThuTrongQuaTrinhThanhTra : 0,
      datThuTrongQuaTrinhThanhTra : 0,
      soViPham : 0,
      soQDXuPhatHCDuocBanHanh : 0,
      soTienViPham : 0,
      soTienXuPhatViPham : 0,
      soTienKienNghiThuHoi : 0,
      soTienTichThuXuLyTaiSanViPham : 0,
      soTienTieuHuyXuLyTaiSanViPham : 0,
      doiTuongViPham : ''
    });
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });

    return pass;
  }

  componentWillUnmount() {

  }

  onChange(name, e) {
    if (name == 'thoiHanThanhTra') {
      this.setState({
        [name]: e.target.value
      },() => {
        this.getThoiHanThanhTra()
      })
    } else if (name == 'canCuThanhTraLai') {
      this.setState({
        [name]: e.target.value
      }, ()=> {
        this.addCanCuThanhTra('danhSachCanCuThanhTraLai', 'canCuThanhTraLai','dataThanhTraLai')
      })
    } else if (name == 'donViViPham') {
      this.setState({
        [name]: e.target.value
      }, ()=> {
        this.addCanCuThanhTra('danhSachDonViViPham', 'donViViPham','dataDonViViPham')
      })
    } else if (name == 'doiTuongThanhTra' || name == 'noiDungThanhTra') {
      this.setState({
        [name]: e.target.value
      },() => {
        if (this.state.noiDungThanhTra && this.state.doiTuongThanhTra) {
          let data = [...this.state.dataDoiTuongThanhTra];

          let doiTuongThanhTra = data.filter(state => {
            return state.doiTuongThanhTraId == this.state.doiTuongThanhTra
          })

          let tenCuocThanhTra = this.state.noiDungThanhTra + ' tại ' + doiTuongThanhTra[0].ten;
          this.setState({
            ten: tenCuocThanhTra
          })
        } else if (this.state.noiDungThanhTra == '' && this.state.doiTuongThanhTra) {
          let data = [...this.state.dataDoiTuongThanhTra];

          let doiTuongThanhTra = data.filter(state => {
            return state.doiTuongThanhTraId == this.state.doiTuongThanhTra
          })

          let tenCuocThanhTra = doiTuongThanhTra[0].ten;
          this.setState({
            ten: tenCuocThanhTra
          })
        } else if (this.state.noiDungThanhTra && this.state.doiTuongThanhTra == '') {
          let tenCuocThanhTra = this.state.noiDungThanhTra
          this.setState({
            ten: tenCuocThanhTra
          })
        } else if (this.state.noiDungThanhTra == '' && this.state.doiTuongThanhTra == '') {
          this.setState({
            ten: ''
          })
        }
      })
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      if (name == 'ngayCongBoQuyetDinhThanhTra') {
        this.setState({
          [name]: e._d
        },() => {
          this.getThoiHanThanhTra()
        })
      } else {
        this.setState({
          [name]: e._d
        })
      }
    } else {
      if (name == 'ngayCongBoQuyetDinhThanhTra') {
        this.setState({
          [name]: e
        },() => {
          this.getThoiHanThanhTra()
        })
      } else {
        this.setState({
          [name]: e
        })
      }
    }
  }

  addCanCuThanhTra(arr, value, _data) {

    let data = [...this.state[_data]];

    let valueText = data.filter(state => {
      return state.giaTri == this.state[value]
    })

    let text = valueText.length > 0 ? valueText[0].ten : '';

    let newArr = [...this.state[arr]];

    let arrCheck = newArr.filter(state => {
      return state.ten == text
    })

    if (this.state[value]) {
      if (arrCheck.length > 0) {
        this.setState({
          [value]: ''
        })
      } else {
        let newItem = {
          ten: text
        }
        this.setState({
          [arr]: [
            ...this.state[arr],
            newItem
          ],
          [value]: ''
        })
      }
    }
    return;
  }

  addDonVi(arr, value, e) {
    if (typeof e != 'undefined') {
      e.preventDefault();
    }
    let newArr = [...this.state[arr]];

    let arrCheck = newArr.filter(state => {
      return state.ten == this.state[value]
    })

    if (this.state[value]) {
      if (arrCheck.length > 0) {
        this.setState({
          [value]: ''
        })
      } else {
        if (arr == 'danhSachDonViThanhTra') {
          let Item = {
            giaTri: this.state[value],
            ten: this.state[value]
          }
          this.setState({
            dataDonViViPham: [
              ...this.state.dataDonViViPham,
              Item
            ]
          })
        }
        let newItem = {
          ten: this.state[value]
        }
        this.setState({
          [arr]: [
            ...this.state[arr],
            newItem
          ],
          [value]: ''
        })
      }
    }
    return;
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    })
    if (!e) {

    }
  }

  removeDonVi(arr, index) {
    let newData = [...this.state[arr]];
    newData.splice(index, 1);
    this.setState({
      [arr]: newData
    })
    if (arr == 'danhSachDonViThanhTra') {
      let data = [...this.state.dataDonViViPham];

      let dataCheck = data.filter(state => {
        return state.giaTri != this.state.danhSachDonViThanhTra[index].ten
      })

      let dataSelected = [...this.state.danhSachDonViViPham]

      let newDataSelected = dataSelected.filter(state => {
        return state.ten != this.state.danhSachDonViThanhTra[index].ten
      })

      this.setState({
        dataDonViViPham: [
          ...dataCheck
        ],
        danhSachDonViViPham: [
          ...newDataSelected
        ]
      })
    }
  }

  onFileChange(data, type) {
    if (type == 'KET_LUAN_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.ketLuanTranhTra = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    if (type == 'KET_LUAN_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.ketLuanTranhTra = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }


  }

  addItem() {
    let newItem = {
      hoVaTen: '',
      donVi: '',
      chucVu: '',
      ngaySinh: '',
      vaiTroThanhVienDoan: ''
    }

    this.setState({
      dataThanhVienDoan: [
        ...this.state.dataThanhVienDoan,
        newItem
      ]
    })
  }

  onItemChange(data, index) {

    this.state.dataThanhVienDoan[index] = data;
    this.setState({
      dataThanhVienDoan: this.state.dataThanhVienDoan
    })
  }

  onItemRemove(index) {
    let dataThanhVienDoan = [...this.state.dataThanhVienDoan];
    dataThanhVienDoan.splice(index, 1);
    this.setState({
      dataThanhVienDoan: dataThanhVienDoan
    })
  }

  getThoiHanThanhTra() {
    if (this.state.ngayCongBoQuyetDinhThanhTra) {
      this.setState({
        getThoiHanThanhTra: true
      })
      let params = {
        thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
        ngayCongBoQD: moment(this.state.ngayCongBoQuyetDinhThanhTra).add(7,'hours').toISOString()
      }
      ThanhTra.actions.getThoiHanThanhTra.request('',params).then(res => {
        if (res.data) {
          this.setState({
            ngayHetHanThanhTra: moment(new Date(res.data)).format('DD/MM/YYYY'),
            ngayHetHanThanhTraISO: res.data
          })
          this.setState({
            getThoiHanThanhTra: false
          })
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          getThoiHanThanhTra: false
        })
      });
    } else {
      this.setState({
        ngayHetHanThanhTra: '',
        ngayHetHanThanhTraISO: null
      })
    }
  }

  render() {
    return (
      <div className="center reception-container wrap-block">
        <div className="back-foward">
          <Link onClick={ browserHistory.goBack } title="">Về trang trước</Link>
        </div>
        <ShowIf condition={!this.state.dotXuat}>
          <div className="heading">
            <h2 className="heading-title icon-add">
              Thêm mới cuộc thanh tra
            </h2>
          </div>
        </ShowIf>
        <ShowIf condition={this.state.dotXuat}>
          <div className="heading">
            <h2 className="heading-title icon-add">
              Chỉnh sửa cuộc thanh tra
            </h2>
          </div>
        </ShowIf>
        <div className="bottom-content">
        {/*thông tin cuộc thanh tra*/}
          <section className='wrap-block'>
            <div className='row pl15 pr15'>
              <h2 className='title-14 p20'>Thông tin cuộc thanh tra</h2>
            </div>
            <div className='row pl30 pr30'>
              <Input disabled={true} label='Tên cuộc thanh tra' className='col-50' value={this.state.ten} onChange={this.onChange.bind(this, 'ten')} maxLength={500}/>
              <DropDownMulipleUse label='Đối tượng thanh tra' data={this.state.dataDoiTuongThanhTra} className='col-30' selectedValue={this.state.doiTuongThanhTra} onChange={this.onChange.bind(this, 'doiTuongThanhTra')} require bindValidator={this} keyName='doiTuongThanhTraId' valueName='ten'/>
              <Input label='Thời kỳ thanh tra' placeholder='Nhập...' className='col-20' value={this.state.kyThanhTra} onChange={this.onChange.bind(this, 'kyThanhTra')} maxLength={255} />
              <TextArea label='Nội dung thanh tra' className='col-100' value={this.state.noiDungThanhTra} onChange={this.onChange.bind(this, 'noiDungThanhTra')} maxLength={500}/>
            </div>
            <div className='row pl30 pr30'>
              <Input label='Số quyết định về việc thanh tra' className='col-25' value={this.state.soQuyetDinhVeViecThanhTra} onChange={this.onChange.bind(this, 'soQuyetDinhVeViecThanhTra')} require bindValidator={this} channel="formTaoDon" maxLength={255} />
              <DatePicker label='Ngày ra quyết định' className='col-25' value={this.state.ngayRaQuyetDinh} onChange={this.handleChangeDate.bind(this, 'ngayRaQuyetDinh')} require bindValidator={this} channel="formTaoDon"/>
              <DropDownChonLoaiHinhThanhTra label='Loại hình' data={this.state.dataLoaiHinhThanhTra} className='col-25' selectedValue={this.state.loaiHinhThanhTra} onChange={this.onChange.bind(this, 'loaiHinhThanhTra')}/>
              <ShowIf condition={this.state.loaiHinhThanhTra == 'THANH_TRA_LAI'}>
                <div className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachCanCuThanhTraLai', 'canCuThanhTraLai')}>
                  <div className='wrap-input-tt-dvph col-25'>
                    <DropDownChonCanCuThanhTraLai label='Căn cứ thanh tra lại' data={this.state.dataThanhTraLai} className='col-100 no-gutter' selectedValue={this.state.canCuThanhTraLai} onChange={this.onChange.bind(this, 'canCuThanhTraLai')}/>
                  </div>
                  <div className='col-75 mb18'>
                    <div className='ds-tt-dvph'>
                      {
                        this.state.danhSachCanCuThanhTraLai.map((item,i) => {
                          return (
                            <div className='tt-dvph-item' key={i}>
                              <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachCanCuThanhTraLai', i)}>×</span>
                              <span className="tt-dvph-value">{item.ten}</span>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
              </ShowIf>
            </div>
            <div className='row pl30 pr30'>
              <DatePicker label='Ngày công bố QĐ thanh tra' className='col-25' value={this.state.ngayCongBoQuyetDinhThanhTra} onChange={this.handleChangeDate.bind(this, 'ngayCongBoQuyetDinhThanhTra')} require bindValidator={this} channel="formTaoDon"/>
              <div className='wrap-thoihan col-25'>
                <Input label='Thời hạn thanh tra (ngày)' type='sdt' className='col-100 no-gutter' value={this.state.thoiHanThanhTra} onChange={this.onChange.bind(this, 'thoiHanThanhTra')}/>
                <span className='thoihan-value'>
                  <ShowIf condition={!this.state.getThoiHanThanhTra}>
                    <span>
                      {this.state.ngayHetHanThanhTra != 'Invalid date' ? this.state.ngayHetHanThanhTra : ''}
                    </span>
                  </ShowIf>
                  <ShowIf condition={this.state.getThoiHanThanhTra}>
                    <span className='icon-loader'></span>
                  </ShowIf>
                </span>
              </div>
              <DropDownMulipleUse label='Hình thức' className='col-25' data={this.state.dataHinhThucThanhTra} selectedValue={this.state.hinhThucThanhTra} onChange={this.onChange.bind(this, 'hinhThucThanhTra')} keyName='giaTri' valueName='ten'/>
              <DropDownChonLinhVucThanhTra label='Lĩnh vực thanh tra' placeholder={null} className='col-25' data={this.state.dataLinhVucThanhTra} selectedValue={this.state.linhVucThanhTra} onChange={this.onChange.bind(this, 'linhVucThanhTra')} require/>
              <ShowIf condition={this.state.hinhThucThanhTra == 'DOT_XUAT'}>
                <TextArea label='Căn cứ thanh tra đột xuất' className='col-100' placeholder='Nhập...' value={this.state.canCuThanhTraDotXuat} onChange={this.onChange.bind(this, 'canCuThanhTraDotXuat')} maxLength={500} />
              </ShowIf>
              {/* <DropDownChonDonViChuTriThanhTra label='Đơn vị chủ trì' require bindValidator={this} className='col-25' data={this.state.dataDonViChuTri} selectedValue={this.state.donViChuTri} onChange={this.onChange.bind(this, 'donViChuTri')}/> */}
              {/* <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViPhoiHop', 'donViPhoiHop')}>
                <div className='wrap-input-tt-dvph col-25'>
                  <Input label='Đơn vị phối hợp' placeholder='Nhập...' className='col-100 no-gutter' value={this.state.donViPhoiHop} onChange={this.onChange.bind(this, 'donViPhoiHop')}/>
                  <button className='btn-add-dvph' type='submit'></button>
                </div>
                <div className='col-75 mb18'>
                  <div className='ds-tt-dvph'>
                    {
                      this.state.danhSachDonViPhoiHop.map((item,i) => {
                        return (
                          <div className='tt-dvph-item' key={i}>
                            <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViPhoiHop', i)}>×</span>
                            <span className="tt-dvph-value">{item.ten}</span>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </form> */}
              <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViThanhTra', 'donViThanhTra')}>
                <div className='wrap-input-tt-dvph col-25'>
                  <Input label='Đơn vị thanh tra liên quan' placeholder='Nhập...' className='col-100 no-gutter' value={this.state.donViThanhTra} onChange={this.onChange.bind(this, 'donViThanhTra')}/>
                  <button className='btn-add-dvph' type='submit'></button>
                </div>
                <div className='col-60 mb18'>
                  <div className='ds-tt-dvph'>
                    {
                      this.state.danhSachDonViThanhTra.map((item,i) => {
                        return (
                          <div className='tt-dvph-item' key={i}>
                            <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViThanhTra', i)}>×</span>
                            <span className="tt-dvph-value">{item.ten}</span>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
                <div className='col-15 mb18 count-dv'>
                  Tổng: {this.state.danhSachDonViThanhTra.length} đơn vị
                </div>
              </form>
            </div>
          </section>
        {/*end thông tin cuộc thanh tra*/}
        <ShowIf condition={false}>
          <div>
            <div className='pl20 pb20 pr20'>
              <div className='line-border'></div>
            </div>
          {/*Gia hạn*/}
            <section className='wrap-block pl20 pr20 mb10'>
              <div className='row pl15 pr15'>
                <p className="txt-bold txt-upper mb10">Gia hạn thanh tra</p>
              </div>
              <div className='row pl10 pr10'>
                <Text className="col-25 mb10" label='Gia hạn đến ngày' value={this.state.ngayHetHanGiaHanThanhTra ? moment(this.state.ngayHetHanGiaHanThanhTra).format('DD/MM/YYYY') : ''}/>
                <TextMessage className="col-100 mb5" label="Lý do gia hạn:"value={this.state.lyDonGiaHan ? this.state.lyDonGiaHan : ''}/>
              </div>
              <ShowIf condition={this.state.showFile}>
                <ContainerFileDinhKem phanLoaiQuyTrinh='GIA_HAN' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuGiaHan} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </ShowIf>
            </section>
          {/*end Gia hạn*/}
          </div>
        </ShowIf>
        <ShowIf condition={this.state.linhVucThanhTra == 'CHUYEN_NGANH'}>
          <div>
            <div className='pl20 pb20 pr20'>
              <div className='line-border'></div>
            </div>
            <section className='wrap-block pl20 pr20 mb10'>
              <ShowIfCheck className='row pl15 pr15' label="Thành lập đoàn" onChange={this.handleCheck.bind(this, 'thanhLapDoan')} checked={this.state.thanhLapDoan}>
                <div className='col-100 no-gutter'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-12 pb20'>Thành viên đoàn</h2>
                  </div>
                  <div className='row pl10 pr10 mb10'>
                    <Input label='Số quyết định' placeholder='Nhập...' className='col-25 mb0-18' require bindValidator={this} channel="formTaoDon" value={this.state.soQuyetDinhThanhLapDoan} onChange={this.onChange.bind(this, 'soQuyetDinhThanhLapDoan')} maxLength={255}/>
                    <DatePicker label='Ngày quyết định' className='col-25 mb0-18' value={this.state.ngayRaQuyetDinhThanhLapDoan} onChange={this.handleChangeDate.bind(this, 'ngayRaQuyetDinhThanhLapDoan')} require bindValidator={this} channel="formTaoDon"/>
                  </div>
                  <ShowIf condition={this.state.showFile}>
                    <div className='wrap-table-show-oncheck'>
                      <DataTableAttachElement addItem={this.addItem.bind(this)} header={ header.thanhTra.TMTVCTT } dataList={ this.state.dataThanhVienDoan } hideButtonExport={true} hidePagination={ true } pageData={ this.state.pageData } parent={ this } search={ this.state.search }
                      tableLoading={ this.state.tableLoading }>
                        <RowItemChiTietThanhVienCuocThanhTra dataVaiTroThanhVienDoan={this.state.dataVaiTroThanhVienDoan} onItemRemove={this.onItemRemove.bind(this)} onItemChange={this.onItemChange.bind(this)}/>
                      </DataTableAttachElement>
                    </div>
                  </ShowIf>
                </div>
              </ShowIfCheck>
            </section>
          </div>
        </ShowIf>
            {/*end Thành viên đoàn*/}
          <div className='mt10'>
            <div className='big-border'></div>
          </div>
        {/*Tiến độ thanh tra*/}
          <section className='wrap-block'>
            <div className='row pl15 pr15'>
              <h2 className='title-14 p20'>Tiến độ thanh tra</h2>
            </div>
            <div className='row pl30 pr30'>
              <DropDownChonTienDoThanhTra label='Tiến độ' className='col-25' data={this.state.dataTienDoThanhTra} require bindValidator={this} selectedValue={this.state.tienDoThanhTra} onChange={this.onChange.bind(this, 'tienDoThanhTra')}/>
            </div>
          </section>
        {/*end Tiến độ thanh tra*/}
        <div className='mt10'>
            <div className='big-border'></div>
          </div>
        {/*Kết luận thanh tra*/}
          <section className='wrap-block'>
            <div className='row pl15 pr15'>
              <h2 className='title-14 p20'>Kết luận thanh tra</h2>
            </div>
            <div className='row pl30 pr30'>
              <Input label='Số kết luận thanh tra' placeholder='Nhập...' className='col-25' value={this.state.soKetLuanThanhTra} onChange={this.onChange.bind(this, 'soKetLuanThanhTra')} maxLength={255}/>
              <DatePicker label='Ngày ban hành' className='col-25' endDate={new Date()} value={this.state.ngayBanHanhKetLuanThanhTra} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhKetLuanThanhTra')}/>
              <DropDownMulipleUse label='Đơn vị ban hành' className='col-25' selectedValue={this.state.donViBanHanh} onChange={this.onChange.bind(this, 'donViBanHanh')} data={this.state.dataDonViBanHanh} keyName='giaTri' valueName='ten'/>
              <TextArea label='Tóm tắt kết luận thanh tra' className='col-100' placeholder='Nhập...' value={this.state.tomTatKetLuanThanhTra} onChange={this.onChange.bind(this, 'tomTatKetLuanThanhTra')} maxLength={1000} />

            </div>
            <ShowIf condition={this.state.showFile}>
              <div className='pl20 pr20'>
                <ContainerFileDinhKem phanLoaiQuyTrinh='KET_LUAN_THANH_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuKetLuanThanhTra} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
          </section>
        {/*end Kết luận thanh tra*/}
          <div className='mt10 pl20 pb20 pr20'>
            <div className='line-border'></div>
          </div>
        {/*Chuyển cơ quan điều tra*/}
          <section className='wrap-block pl20 pr20'>
            <ShowIfCheck className='row pl15 pr15' label="Chuyển cơ quan điều tra" onChange={this.handleCheck.bind(this, 'chuyenCoQuanDieuTra')} checked={this.state.chuyenCoQuanDieuTra}>
              <div className='col-100 no-gutter'>
                <div className='row pl15 pr15'>
                  <h2 className='title-12 pb20'>Chuyển cơ quan điều tra</h2>
                </div>
                <div className='row pl10 pr10'>
                  <DropDownMulipleUse label='Tên cơ quan' className='col-50' require bindValidator={this} selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')} data={this.state.dataCoQuanDieuTra} keyName='coQuanQuanLyId' valueName='ten'/>
                  <InputNumber label='Số vụ' className='col-25' require bindValidator={this} channel="formTaoDon" value={Number(this.state.soVuDieuTra)} onChange={this.onChange.bind(this, 'soVuDieuTra')}/>
                  <InputNumber label='Số đối tượng' className='col-25' require bindValidator={this} channel="formTaoDon" value={Number(this.state.soDoiTuongDieuTra)} onChange={this.onChange.bind(this, 'soDoiTuongDieuTra')} maxLength={255}/>
                </div>
              </div>
            </ShowIfCheck>
          </section>
        {/*end Chuyển cơ quan điều tra*/}
          <div className='mt10 pl20 pb20 pr20'>
            <div className='line-border'></div>
          </div>
        {/*Vi phạm Hành chính*/}
          <ShowIf condition={this.state.linhVucThanhTra == 'XAY_DUNG_CO_BAN' || this.state.linhVucThanhTra == 'HANH_CHINH'}>
            <section className='wrap-block pl20 pr20 mb10'>
              <ShowIfCheck className='row pl15 pr15' label="Vi phạm" onChange={this.handleCheck.bind(this, 'viPham')} checked={this.state.viPham}>
                <div className='col-100 no-gutter'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-12 pb20'>Nội dung vi phạm</h2>
                  </div>
                  <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Tổng vi phạm</p>
                    <Input className="col-50" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienThuViPham} onChange={this.onChange.bind(this, 'tienThuViPham')}/>
                    <Input className="col-50" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datThuViPham} onChange={this.onChange.bind(this, 'datThuViPham')}/>
                  </div>
                  <div className="col-50 no-gutter clear-left">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị thu hồi</p>
                    <Input className="col-50" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienTraKienNghiThuHoi} onChange={this.onChange.bind(this, 'tienTraKienNghiThuHoi')}/>
                    <Input className="col-50" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datTraKienNghiThuHoi} onChange={this.onChange.bind(this, 'datTraKienNghiThuHoi')}/>
                  </div>
                  <div className="col-50 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị khác</p>
                    <Input className="col-50" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienTraKienNghiKhac} onChange={this.onChange.bind(this, 'tienTraKienNghiKhac')}/>
                    <Input className="col-50" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datTraKienNghiKhac} onChange={this.onChange.bind(this, 'datTraKienNghiKhac')}/>
                  </div>
                  <div className="col-50 no-gutter clear-left">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                    <InputNumber className="col-50" label="Tổ chức" value={this.state.toChucXuLyHanhChinhViPham} onChange={this.onChange.bind(this, 'toChucXuLyHanhChinhViPham')}/>
                    <InputNumber className="col-50" label="Cá nhân" value={this.state.caNhanXuLyHanhChinhViPham} onChange={this.onChange.bind(this, 'caNhanXuLyHanhChinhViPham')}/>
                  </div>
                  <div className="col-50 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi trong quá trình thanh tra</p>
                    <Input className="col-50" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'tienThuTrongQuaTrinhThanhTra')}/>
                    <Input className="col-50" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'datThuTrongQuaTrinhThanhTra')}/>
                  </div>
                  <div className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham')}>
                    <div className='wrap-input-tt-dvph col-25'>
                      <DropDownMulipleUse label='Đơn vị vi phạm' data={this.state.dataDonViViPham} className='col-100 no-gutter' selectedValue={this.state.donViViPham} onChange={this.onChange.bind(this, 'donViViPham')} keyName='giaTri' valueName='ten'/>
                    </div>
                    <div className='col-60 mb18'>
                      <div className='ds-tt-dvph'>
                        {
                          this.state.danhSachDonViViPham.map((item,i) => {
                            return (
                              <div className='tt-dvph-item' key={i}>
                                <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViViPham', i)}>×</span>
                                <span className="tt-dvph-value">{item.ten}</span>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                    <div className='col-15 mb18 count-dv'>
                      Tổng: {this.state.danhSachDonViViPham.length} đơn vị
                    </div>
                  </div>
                </div>
                </div>
              </ShowIfCheck>
            </section>
          </ShowIf>
        {/*end Vi phạm Hành chính*/}

        {/*Vi phạm Tài chính*/}
          <ShowIf condition={this.state.linhVucThanhTra == 'TAI_CHINH'}>
            <section className='wrap-block pl20 pr20 mb10'>
              <ShowIfCheck className='row pl15 pr15' label="Vi phạm" onChange={this.handleCheck.bind(this, 'viPham')} checked={this.state.viPham}>
                <div className='col-100 no-gutter'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-12 pb20'>Nội dung vi phạm</h2>
                  </div>
                  <div className="row pl10 pr10">
                    <div className="col-25 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Tổng vi phạm</p>
                      <Input className="col-100" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienThuViPham} onChange={this.onChange.bind(this, 'tienThuViPham')}/>
                    </div>
                    <div className="col-25 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị thu hồi</p>
                      <Input className="col-100" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienTraKienNghiThuHoi} onChange={this.onChange.bind(this, 'tienTraKienNghiThuHoi')}/>
                    </div>
                    <div className="col-25 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị khác</p>
                      <Input className="col-100" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienTraKienNghiKhac} onChange={this.onChange.bind(this, 'tienTraKienNghiKhac')}/>
                    </div>
                    <div className="col-50 no-gutter clear-left">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                      <InputNumber className="col-50" label="Tổ chức" value={this.state.toChucXuLyHanhChinhViPham} onChange={this.onChange.bind(this, 'toChucXuLyHanhChinhViPham')}/>
                      <InputNumber className="col-50" label="Cá nhân" value={this.state.caNhanXuLyHanhChinhViPham} onChange={this.onChange.bind(this, 'caNhanXuLyHanhChinhViPham')}/>
                    </div>
                    <div className="col-50 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi trong quá trình thanh tra</p>
                      <Input className="col-50" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'tienThuTrongQuaTrinhThanhTra')}/>
                      <Input className="col-50" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'datThuTrongQuaTrinhThanhTra')}/>
                    </div>
                    <div className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham')}>
                      <div className='wrap-input-tt-dvph col-25'>
                        <DropDownMulipleUse label='Đơn vị vi phạm' data={this.state.dataDonViViPham} className='col-100 no-gutter' selectedValue={this.state.donViViPham} onChange={this.onChange.bind(this, 'donViViPham')} keyName='giaTri' valueName='ten'/>
                      </div>
                      <div className='col-60 mb18'>
                        <div className='ds-tt-dvph'>
                          {
                            this.state.danhSachDonViViPham.map((item,i) => {
                              return (
                                <div className='tt-dvph-item' key={i}>
                                  <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViViPham', i)}>×</span>
                                  <span className="tt-dvph-value">{item.ten}</span>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                      <div className='col-15 mb18 count-dv'>
                        Tổng: {this.state.danhSachDonViViPham.length} đơn vị
                      </div>
                    </div>
                  </div>
                </div>
              </ShowIfCheck>
            </section>
          </ShowIf>
        {/*end Vi phạm Tài chính*/}

        {/*Vi phạm Đất đai*/}
          <ShowIf condition={this.state.linhVucThanhTra == 'DAT_DAI'}>
            <section className='wrap-block pl20 pr20 mb10'>
              <ShowIfCheck className='row pl15 pr15' label="Vi phạm" onChange={this.handleCheck.bind(this, 'viPham')} checked={this.state.viPham}>
                <div className='col-100 no-gutter'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-12 pb20'>Nội dung vi phạm</h2>
                  </div>
                  <div className="row pl10 pr10">
                    <div className="col-100 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Tổng vi phạm</p>
                      <Input className="col-25" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienThuViPham} onChange={this.onChange.bind(this, 'tienThuViPham')}/>
                      <Input className="col-25" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datThuViPham} onChange={this.onChange.bind(this, 'datThuViPham')}/>
                    </div>
                    <div className="col-100 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Các dạng vi phạm về đất</p>
                      <Input className="col-25" type="sdt" align="right" label="Đất lấn chiếm (m2)" value={this.state.datLanChiem} onChange={this.onChange.bind(this, 'datLanChiem')}/>
                      <Input className="col-25" type="sdt" align="right" label="Giao đất, cấp đất sai đối tượng QĐ (m2)" value={this.state.giaoDatCapDatSaiDoiTuong} onChange={this.onChange.bind(this, 'giaoDatCapDatSaiDoiTuong')}/>
                      <Input className="col-25" type="sdt" align="right" label="Cấp, bán đất trái thẩm quyền (m2)" value={this.state.capBanDatTraiThamQuyen} onChange={this.onChange.bind(this, 'capBanDatTraiThamQuyen')}/>
                      <Input className="col-25" type="sdt" align="right" label="Cấp GCNQSD đất sai (m2)" value={this.state.capGCNQSDDatSai} onChange={this.onChange.bind(this, 'capGCNQSDDatSai')}/>
                      <Input className="col-25" type="sdt" align="right" label="CN, cho thuê không đúng QĐ (m2)" value={this.state.choThueKhongDungQD} onChange={this.onChange.bind(this, 'choThueKhongDungQD')}/>
                      <Input className="col-25" type="sdt" align="right" label="SD đất không đúng MĐ, sai QĐ (m2)" value={this.state.datKhongDungMDSaiQD} onChange={this.onChange.bind(this, 'datKhongDungMDSaiQD')}/>
                      <Input className="col-25" type="sdt" align="right" label="Bỏ hoang hóa (m2)" value={this.state.boHoangHoa} onChange={this.onChange.bind(this, 'boHoangHoa')}/>
                      <Input className="col-25" type="sdt" align="right" label="Vi phạm khác (m2)" value={this.state.viPhamKhac} onChange={this.onChange.bind(this, 'viPhamKhac')}/>

                    </div>
                    <div className="col-50 no-gutter clear-left">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị thu hồi</p>
                      <Input className="col-50" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienTraKienNghiThuHoi} onChange={this.onChange.bind(this, 'tienTraKienNghiThuHoi')}/>
                      <Input className="col-50" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datTraKienNghiThuHoi} onChange={this.onChange.bind(this, 'datTraKienNghiThuHoi')}/>
                    </div>
                    <div className="col-50 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị khác</p>
                      <Input className="col-50" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienTraKienNghiKhac} onChange={this.onChange.bind(this, 'tienTraKienNghiKhac')}/>
                      <Input className="col-50" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datTraKienNghiKhac} onChange={this.onChange.bind(this, 'datTraKienNghiKhac')}/>
                    </div>
                    <div className="col-50 no-gutter clear-left">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                      <InputNumber className="col-50" label="Tổ chức" value={this.state.toChucXuLyHanhChinhViPham} onChange={this.onChange.bind(this, 'toChucXuLyHanhChinhViPham')}/>
                      <InputNumber className="col-50" label="Cá nhân" value={this.state.caNhanXuLyHanhChinhViPham} onChange={this.onChange.bind(this, 'caNhanXuLyHanhChinhViPham')}/>
                    </div>
                    <div className="col-50 no-gutter">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi trong quá trình thanh tra</p>
                      <Input className="col-50" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'tienThuTrongQuaTrinhThanhTra')}/>
                      <Input className="col-50" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'datThuTrongQuaTrinhThanhTra')}/>
                    </div>
                    <div className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham')}>
                      <div className='wrap-input-tt-dvph col-25'>
                        <DropDownMulipleUse label='Đơn vị vi phạm' data={this.state.dataDonViViPham} className='col-100 no-gutter' selectedValue={this.state.donViViPham} onChange={this.onChange.bind(this, 'donViViPham')} keyName='giaTri' valueName='ten'/>
                      </div>
                      <div className='col-60 mb18'>
                        <div className='ds-tt-dvph'>
                          {
                            this.state.danhSachDonViViPham.map((item,i) => {
                              return (
                                <div className='tt-dvph-item' key={i}>
                                  <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViViPham', i)}>×</span>
                                  <span className="tt-dvph-value">{item.ten}</span>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                      <div className='col-15 mb18 count-dv'>
                        Tổng: {this.state.danhSachDonViViPham.length} đơn vị
                      </div>
                    </div>
                  </div>
                </div>
              </ShowIfCheck>
            </section>
          </ShowIf>
        {/*end Vi phạm Đất đai*/}

        {/*Vi phạm Chuyên ngành*/}
          <ShowIf condition={this.state.linhVucThanhTra == 'CHUYEN_NGANH'}>
            <section className='wrap-block pl20 pr20 mb10'>
              <ShowIfCheck className='row pl15 pr15' label="Vi phạm" onChange={this.handleCheck.bind(this, 'viPham')} checked={this.state.viPham}>
                <div className='col-100 no-gutter'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-12 pb20'>Nội dung vi phạm</h2>
                  </div>
                  <div className="row pl10 pr10">
                    <div className="col-100 no-gutter">
                      <InputNumber className="col-25" label="Số vi phạm" value={this.state.soViPham} onChange={this.onChange.bind(this, 'soViPham')}/>
                      <Input className="col-25" label="Số QĐ xử phạt HC được ban hành" placeholder='Nhập...' value={this.state.soQDXuPhatHCDuocBanHanh} onChange={this.onChange.bind(this, 'soQDXuPhatHCDuocBanHanh')}/>
                    </div>
                    <div className="col-100 no-gutter clear-left">
                      <Input className="col-25" type="sdt" align="right" label="Số tiền vi phạm (đ)" value={this.state.soTienViPham} onChange={this.onChange.bind(this, 'soTienViPham')}/>
                      <Input className="col-25" type="sdt" align="right" label="Số tiền xử phạt vi phạm (m2)" value={this.state.soTienXuPhatViPham} onChange={this.onChange.bind(this, 'soTienXuPhatViPham')}/>
                      <Input className="col-25" type="sdt" align="right" label="Số tiền kiến nghị thu hồi (m2)" value={this.state.soTienKienNghiThuHoi} onChange={this.onChange.bind(this, 'soTienKienNghiThuHoi')}/>
                    </div>
                    <div className="col-100 no-gutter clear-left">
                      <p className="txt-bold txt-upper mb10 pl5 pr5">Số tiền xử lý tài sản vi phạm</p>
                      <Input className="col-25" type="sdt" align="right" label="Tịch thu (đ)" value={this.state.soTienTichThuXuLyTaiSanViPham} onChange={this.onChange.bind(this, 'soTienTichThuXuLyTaiSanViPham')}/>
                      <Input className="col-25" type="sdt" align="right" label="Tiêu hủy (đ)" value={this.state.soTienTieuHuyXuLyTaiSanViPham} onChange={this.onChange.bind(this, 'soTienTieuHuyXuLyTaiSanViPham')}/>
                    </div>
                    <div className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViViPham', 'donViViPham')}>
                      <div className='wrap-input-tt-dvph col-25'>
                        <DropDownMulipleUse label='Đơn vị vi phạm' data={this.state.dataDonViViPham} className='col-100 no-gutter' selectedValue={this.state.donViViPham} onChange={this.onChange.bind(this, 'donViViPham')} keyName='giaTri' valueName='ten'/>
                      </div>
                      <div className='col-60 mb18'>
                        <div className='ds-tt-dvph'>
                          {
                            this.state.danhSachDonViViPham.map((item,i) => {
                              return (
                                <div className='tt-dvph-item' key={i}>
                                  <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViViPham', i)}>×</span>
                                  <span className="tt-dvph-value">{item.ten}</span>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                      <div className='col-15 mb18 count-dv'>
                        Tổng: {this.state.danhSachDonViViPham.length} đơn vị
                      </div>
                    </div>
                  </div>
                </div>
              </ShowIfCheck>
            </section>
          </ShowIf>
        {/*end Vi phạm Chuyên ngành*/}
          <div className='mt10 pl20 pb20 pr20'>
            <div className='line-border'></div>
          </div>
        {/*Phát hiện tham nhũng*/}
          <section className='wrap-block pl20 pr20'>
            <ShowIfCheck className='row pl15 pr15' label="Có phát hiện tham nhũng" onChange={this.handleCheck.bind(this, 'phatHienThamNhung')} checked={this.state.phatHienThamNhung}>
              <div className='col-100 no-gutter'>
                <div className='row pl15 pr15'>
                  <h2 className='title-12 pb20'>Nội dung vi phạm</h2>
                </div>
                <div className="row pl10 pr10">
                  <InputNumber className="col-25" label="Số vụ" require bindValidator={this} channel="formTaoDon" value={this.state.soVuThamNhung} onChange={this.onChange.bind(this, 'soVuThamNhung')}/>
                  <InputNumber className="col-25" label="Số đối tượng" require bindValidator={this} channel="formTaoDon" value={this.state.soDoiTuongThamNhung} onChange={this.onChange.bind(this, 'soDoiTuongThamNhung')} maxLength={255}/>
                  <div className="col-100 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Tài sản tham nhũng</p>
                    <Input className="col-25" type="sdt" align="right" label="Tiền (đ)" value={this.state.tienThamNhung} onChange={this.onChange.bind(this, 'tienThamNhung')}/>
                    <Input className="col-25" type="sdt" align="right" label="Tài sản khác (đ)" value={this.state.taiSanKhacThamNhung} onChange={this.onChange.bind(this, 'taiSanKhacThamNhung')}/>
                    <Input className="col-25" type="sdt" align="right" label="Đất (m2)" value={this.state.datThamNhung} onChange={this.onChange.bind(this, 'datThamNhung')}/>
                  </div>
                  <div className="col-100 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị thu hồi</p>
                    <Input className="col-25" type="sdt" align="right" label="Tiền (đ)" value={this.state.tienKienNghiThuHoi} onChange={this.onChange.bind(this, 'tienKienNghiThuHoi')}/>
                    <Input className="col-25" type="sdt" align="right" label="Tài sản khác (đ)" value={this.state.taiSanKhacKienNghiThuHoi} onChange={this.onChange.bind(this, 'taiSanKhacKienNghiThuHoi')}/>
                    <Input className="col-25" type="sdt" align="right" label="Đất (m2)" value={this.state.datKienNghiThuHoi} onChange={this.onChange.bind(this, 'datKienNghiThuHoi')}/>
                  </div>
                  <div className="col-100 no-gutter clear-left">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Đã thu</p>
                    <Input className="col-25" type="sdt" align="right" label="Tiền (đ)" value={this.state.tienDaThu} onChange={this.onChange.bind(this, 'tienDaThu')}/>
                    <Input className="col-25" type="sdt" align="right" label="Tài sản khác (đ)" value={this.state.taiSanKhacDaThu} onChange={this.onChange.bind(this, 'taiSanKhacDaThu')}/>
                    <Input className="col-25" type="sdt" align="right" label="Đất (m2)" value={this.state.datDaThu} onChange={this.onChange.bind(this, 'datDaThu')}/>
                  </div>
                  <div className="col-50 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                    <InputNumber className="col-50" label="Tổ chức" value={this.state.toChucXuLyHanhChinhThamNhung} onChange={this.onChange.bind(this, 'toChucXuLyHanhChinhThamNhung')}/>
                    <InputNumber className="col-50" label="Cá nhân" value={this.state.caNhanXuLyHanhChinhThamNhung} onChange={this.onChange.bind(this, 'caNhanXuLyHanhChinhThamNhung')}/>
                  </div>
                  <div className="col-50 no-gutter">
                    <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý trách nhiệm người đứng đầu</p>
                    <InputNumber className="col-50" label="Số người" value={this.state.soNguoiXuLyTrachNhiemDungDau} onChange={this.onChange.bind(this, 'soNguoiXuLyTrachNhiemDungDau')}/>
                    <Input className="col-50" label="Tên người" placeholder='Nhập...' value={this.state.tenNguoi} onChange={this.onChange.bind(this, 'tenNguoi')} maxLength={255}/>
                  </div>
                </div>
              </div>
            </ShowIfCheck>
          </section>
        {/*end Phát hiện tham nhũng*/}
          <div className='mt10 pb20'>
            <div className='big-border'></div>
          </div>
          <ShowIf condition={this.state.showFile}>
            <div className='pl20 pr20 pb10'>
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThu} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
            </div>
          </ShowIf>
        </div>
        <div className="action-form-wrap pt35 pb5">
          <div className="box-bottom">
            <Link className="btn-action btn-close" onClick={ browserHistory.goBack }><span>Đóng</span></Link>
            <ShowIf condition={!this.state.dotXuat}>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
            </ShowIf>
            <ShowIf condition={this.state.dotXuat}>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSaveExistElement.bind(this)}><span>Lưu</span></Link>
            </ShowIf>
          </div>
        </div>
      </div>
    );
  }
}

ThemMoiCuocThanhTra.defaultProps = {
  validators: {},
  dotXuat: false,
  params: {
    id: ''
  }
}

export default ThemMoiCuocThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/ThemMoiCuocThanhTra.jsx